import { render } from "./LocationIcon.vue?vue&type=template&id=01361c64&scoped=true"
import script from "./LocationIcon.vue?vue&type=script&lang=js"
export * from "./LocationIcon.vue?vue&type=script&lang=js"

import "./LocationIcon.vue?vue&type=style&index=0&id=01361c64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01361c64"]])

export default __exports__